



















import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { IRepairEstimateRequest, RepairEstimateRequest } from "@/models/repair-estimate-request.entity";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";

@Component({
  components: {
    ConfirmActionDialog
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class RepairEstimateRequestChangeExpirationDialog extends mixins(PermissionMixin) implements IDialog {
  @Prop()
  value!: IRepairEstimateRequest;

  valueCopy = new RepairEstimateRequest(this.value);

  isDialogActive = false;

  isUpdateLoading = false;

  open() {
    this.valueCopy = new RepairEstimateRequest(this.value);
    this.isDialogActive = true;
  }

  close() {
    this.isDialogActive = false;
  }

  async confirm() {
    try {
      this.isUpdateLoading = true;
      await this.value.updatePartial({
        date: this.valueCopy.date
      });
      this.close();
    } catch (e) {
      handleError(e);
    } finally {
      this.isUpdateLoading = false;
    }
  }
}
